import { render, staticRenderFns } from "./VEmployerRoleTemplate.vue?vue&type=template&id=4be72742&lang=pug"
import script from "./VEmployerRoleTemplate.vue?vue&type=script&lang=ts"
export * from "./VEmployerRoleTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports